<template lang="pug">
  app-focus-lock
    el-dialog(
      :visible="dialogVisible"
      :title="`${formTitle} Company`"
      :close-on-click-modal="false"
      v-on:update:visible="closeDialog"
      top="5vh" width="100%"
    ).el-dialog__max-w-700.mx-auto.px-3.px-lg-0
      el-form(
        :model="editedItem"
        status-icon
        ref="form"
        label-position="top"
        :rules="rules"
      )
        .row.mb-3
          el-form-item(label="Company Name" prop="name").col-sm-12
            el-input(v-model="editedItem.name")

          el-form-item(label="Address").col-sm-12
            el-input(v-model="editedItem.address")

          el-form-item(label="City").col-sm-4
            el-input(v-model="editedItem.city")

          el-form-item(label="State").col-sm-4
            el-select(v-model="editedItem.state" placeholder="Select").w-100
              el-option(
                v-for="(state, index) in states" :key="index"
                :label="state[1]" :value="state[0]"
              )

          el-form-item(label="Zip Code").col-sm-4
            el-input(v-model="editedItem.zip")

          el-form-item(label="Email" prop="email").col-sm-6
            el-input(v-model="editedItem.email")

          el-form-item(label="Phone" prop='phone').col-sm-6
            el-input(
              v-model="editedItem.phone"
              v-mask="'(###) ###-####'" type="tel" placeholder="(123) 456-7890"
            )

      .dialog-footer(slot="footer")
        .row
          .col-auto(v-if="!isNew")
            el-button(@click="$emit('delete-item')") Delete Company
          .col
            el-button(@click="closeDialog") Cancel
            el-button(type="primary" @click="validateForm('form')"  v-loading="loading")
              template(v-if="isNew") Save
              template(v-else) Update
</template>

<script>
import { mask } from 'vue-the-mask';
import { states } from '@/data/lookups';

export default {
  name: 'DialoAaddEditCompany',
  directives: { mask },

  props: {
    formTitle: { type: String, default: '' },
    editedItem: { type: Object, default: () => { } },
    dialogVisible: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },

  data() {
    return {
      states,

      rules: {
        name: { required: true, message: 'Name is required', trigger: 'change' },

        email: [
          { required: true, message: 'Email address is required', trigger: 'blur' },
          { type: 'email', message: 'Please enter a valid Email address', trigger: 'blur' },
        ],

        phone: [
          { required: true, message: 'Phone Number is required', trigger: 'blur' },

          // Min 14 length bcoz that includes brackets and space and hyphen. eg. (###) ###-####
          { min: 14, message: 'Length should be 10 digits', trigger: 'blur' },
        ],
      },
    };
  },

  computed: {
    isNew() {
      return this.formTitle === 'Add';
    },
  },

  methods: {
    submitForm() {
      this.$emit('save-item');
    },

    closeDialog() {
      this.$emit('update:dialogVisible', false);
      this.$emit('close-dialog');
    },

    validateForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) return this.submitForm();
        console.log('error submit!!');
        return false;
      });
    },
  },
};
</script>
